export default __webpack_public_path__ + "static/media/homepage.86a93d79.png";